export class ShipmentEventRelatedStopReference {
  id: number;
  sequenceNumber: number;

  constructor(opts: ShipmentEventRelatedStopReference) {
    this.id = opts.id;
    this.sequenceNumber = opts.sequenceNumber;
  }
}
